import { motion } from "framer-motion";
import { Compass, BarChart2, Settings, Users } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export function WhatWeBuildSection() {
  const { t } = useLanguage();

  const systems = [
    {
      icon: Compass,
      title: t("whatWeBuild.architecture.title"),
      description: t("whatWeBuild.architecture.description"),
    },
    {
      icon: BarChart2,
      title: t("whatWeBuild.measurement.title"),
      description: t("whatWeBuild.measurement.description"),
    },
    {
      icon: Settings,
      title: t("whatWeBuild.execution.title"),
      description: t("whatWeBuild.execution.description"),
    },
    {
      icon: Users,
      title: t("whatWeBuild.leadership.title"),
      description: t("whatWeBuild.leadership.description"),
    },
  ];

  return (
    <section id="what-we-build" className="py-20 lg:py-32 bg-card/30">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t("whatWeBuild.title")}{" "}
            <span className="text-primary">{t("whatWeBuild.titleHighlight")}</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {systems.map((system, index) => (
            <motion.div
              key={system.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="card-surface p-6 lg:p-8 text-center hover-lift hover-glow group"
            >
              <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6 group-hover:bg-primary/20 transition-colors">
                <system.icon className="w-8 h-8 text-primary" />
              </div>
              <h3 className="font-display text-xl font-bold text-foreground mb-2">
                {system.title}
              </h3>
              <p className="text-muted-foreground">
                {system.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
